import React from 'react'
import PropTypes from 'prop-types'
import { Menu, Dropdown } from 'antd'

const ChecDropdownWrapper = ({ clickHandler, options, children }) => (
  <Dropdown
    disabled={false}
    overlay={
      <Menu onClick={clickHandler}>
        {options.map(({ key, display }) => (
          <Menu.Item key={key}>{display}</Menu.Item>
        ))}
      </Menu>
    }
  >
    {/* This component triggers on a hover so the children need to be wrapped in a span */}
    <span>{children}</span>
  </Dropdown>
)

ChecDropdownWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  options: PropTypes.array,
  clickHandler: PropTypes.func,
}

export default ChecDropdownWrapper
